import { RecordValues } from '../index';

export type ITyre<TranslationKey extends string = string> = {
  brand: {
    id: number;
    publicKey: string;
    name: string;
  };
  specification: {
    seal: 'Y';
    rftext: string;
    eco: number;
    typeTyre: string;
    electricId: number;
    sportCompatibility: boolean;
    campingCar: number;
    runFlat: boolean;
  };
  dimension: {
    description: string;
    diameter: number;
    width: number;
    height: number;
    fullSize: string;
    rfd: string;
    loadIndexes: number[];
    speedIndexes: string[];
  };
  season: {
    id: number;
    name: string;
    i18nKey: TranslationKey;
    publicKey: string;
    pmsf?: 'N' | 'Y';
  };
  vehicleType: {
    publicKey: string;
    name: string;
  };
  profile: {
    design1: string;
  };
  labelling: {
    noisePerformance: string;
    rollingResistance: string;
    wetGrip: string;
  };
  homologations: Array<{
    publicKey: string;
    brand: string;
  }>;
  prodInfo: string;
  supplierCode: string;
  createdAt: string;
  segment: {
    publicKey: string;
    name: string;
  };
  priceFrame: {
    price: number | null;
    recyclingFee?: number;
    currencyIsoCode: string;
  };
  reference: string;
  pictures: {
    fullView?: string;
  };
  ean: string;
  productType: {
    publicKey: string;
  };
  constructorReference?: string;
  alternativeReference?: string;
};

export const TYRE_IDENTIFIER_FIELD = {
  CAI: 'CAI',
  WYZ_REFERENCE: 'WYZ_REFERENCE',
  CONSTRUCTOR_REFERENCE: 'CONSTRUCTOR_REFERENCE',
} as const;

export type ITyreIdentifierField = RecordValues<typeof TYRE_IDENTIFIER_FIELD>;

type IdentifierType = {
  identifierType: ITyreIdentifierField;
};
type CaiIdentifier = {
  cai: string | undefined;
  alternativeReference: undefined;
  constructorReference: undefined;
} & IdentifierType;
type AlternativeIdentifier = {
  alternativeReference: string | undefined;
  cai: undefined;
  constructorReference: undefined;
} & IdentifierType;
type ConstructorIdentifier = {
  constructorReference: string | undefined;
  cai: undefined;
  alternativeReference: undefined;
} & IdentifierType;

type AllIdentifier = {
  identifierType: 'ALL'; // ONLY for WyzCore
  cai: string | undefined;
  constructorReference: string | undefined;
  alternativeReference: string | undefined;
};

export type AnyTyreIdentifier =
  | CaiIdentifier
  | AlternativeIdentifier
  | ConstructorIdentifier
  | {
      identifierType: undefined;
      cai: undefined;
      constructorReference: undefined;
      alternativeReference: undefined;
    }
  | AllIdentifier;

export type ITyreInfoBox = {
  brand: string;
  ean: string;
  profile: string;
  dimension?: string;
  season?: string | number;
  seasonPmsf?: string;
  vehicleType?: string;
  segment?: string;
  homologations?: {
    publicKey: string;
    brand: string;
  }[];
  prodInfo?: string;
} & AnyTyreIdentifier;
